import { render, staticRenderFns } from "./spoken-langs.vue?vue&type=template&id=00121cdb&scoped=true&"
import script from "./spoken-langs.vue?vue&type=script&lang=js&"
export * from "./spoken-langs.vue?vue&type=script&lang=js&"
import style0 from "./spoken-langs.vue?vue&type=style&index=0&id=00121cdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00121cdb",
  null
  
)

export default component.exports